module.exports = __webpack_public_path__ + "static/neotech_bold-webfont-3c132118ae2ca7c9e6e9dee34a8c23f0.woff";